import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from "./RightButtons.module.css";
import { ButtonGroup } from '../../../components/ButtonGroup';
import Icon from '../../../components/Icon';
import { Icon as IconType } from "../../../components/Icon/Icon.interface";
import { User } from '../../../features/api/apiSlice';

interface RightButtonsProps {
  toggleChat?: () => void;
  toggleChannels?: () => void;
  toggleSamples?: () => void;
  toggleScenes?: () => void;
  activeButton?: string;
  user?: User;
}

const RightButtons: FC<RightButtonsProps> = ({
  toggleChat,
  toggleChannels,
  toggleSamples,
  toggleScenes,
  activeButton: externalActiveButton,
  user
}) => {
  const [localActiveButton, setLocalActiveButton] = useState<string | null>(null);
  const activeButton = externalActiveButton || localActiveButton;
  const navigate = useNavigate();

  const handleButtonClick = (id: string, toggleFn?: () => void, requiresStudioTariff: boolean = false) => {
    if (requiresStudioTariff && !user?.tariff?.studio) {
      navigate('/tariffs');
      return;
    }

    if (activeButton === id) {
      setLocalActiveButton(null);
    } else {
      setLocalActiveButton(id);
    }

    toggleFn?.();
  };

  const buttons: { name: IconType; id: string; toggleFn: (() => void) | undefined; requiresStudioTariff: boolean }[] = [
    { name: "studio-scene", id: "scenes", toggleFn: toggleScenes, requiresStudioTariff: true },
    { name: "studio-samples", id: "samples", toggleFn: toggleSamples, requiresStudioTariff: true },
    { name: "studio-chat", id: "chat", toggleFn: toggleChat, requiresStudioTariff: true },
    { name: "studio-channels", id: "channels", toggleFn: toggleChannels, requiresStudioTariff: false },
  ];

  return (
    <div className={styles["right-buttons"]}>
      <ButtonGroup>
        <ul className={styles["right-buttons__group"]}>
          {buttons.map((button) => (
            <li
              key={button.id}
              className={styles["right-buttons__item"]}
              onClick={() => handleButtonClick(button.id, button.toggleFn, button.requiresStudioTariff)}
            >
              <div
                className={`${styles["right-buttons__icon-wrapper"]} ${activeButton === button.id ? styles["right-buttons__icon-wrapper--active"] : ""}`}
              >
                <Icon name={button.name} />
              </div>
            </li>
          ))}
        </ul>
      </ButtonGroup>
    </div>
  );
};

export default RightButtons;